var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-avatar',_vm._g({staticClass:"white--text text-uppercase",attrs:{"size":26,"color":"info"}},on),[_c('small',[_vm._v(_vm._s(_vm.displayText))])])]}}])},[_c('span',{staticClass:"caption"},[_vm._v(_vm._s(_vm.profile ? _vm.profile.name_display : "user not set"))])])}
var staticRenderFns = []

export { render, staticRenderFns }